import { render, staticRenderFns } from "./SerialNumberAddNew.vue?vue&type=template&id=6a659d7d&scoped=true&"
import script from "./SerialNumberAddNew.vue?vue&type=script&lang=js&"
export * from "./SerialNumberAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SerialNumberAddNew.vue?vue&type=style&index=0&id=6a659d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a659d7d",
  null
  
)

export default component.exports